import { AutoStopControl } from "appworks/ui/controls/standard/button/auto-stop-control";
import { UIFlag, uiFlags } from "appworks/ui/flags/ui-flags";

export class AgsCancelAutoControl extends AutoStopControl {
    public setEnabled(enabled: boolean): void {
        // GMDEV-2331: Autoplay Stop Button should always be enabled during autoplay.
        super.setEnabled(this.gameIsAutoPlay());
    }

    protected gameIsAutoPlay(): boolean {
        return uiFlags.has(UIFlag.AUTO_SPIN);
    }
}
